import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";

export default function Awards() {
  const { lang, t } = useLang();
  const { awards } = useData();

  return (
    <section id="awards" className="section">
      <div className="section__header">
        <h2 className="section__title">{t.nav.awards}</h2>
      </div>

      <ul className="awards">
        {awards.map((a) => {
          const item = a[lang] || a.en;
          return (
            <li key={a.id} className="award">
              <div className="award__date">{item.date}</div>
              <div className="award__body">
                <div className="award__title">
                  {a.link ? (
                    <a
                      href={a.link}
                      className="award__title-link"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.title}
                      <span className="award__title-arrow" aria-hidden="true">
                        ↗
                      </span>
                    </a>
                  ) : (
                    item.title
                  )}
                </div>
                <div className="award__venue">{item.venue}</div>
                {item.coAuthors && (
                  <div className="award__coauthors">{item.coAuthors}</div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
